var jcsfApp;
(function (jcsfApp) {
    var app;
    (function (app) {
        var auth;
        (function (auth) {
            var ErrorHandlerController = (function () {
                function ErrorHandlerController() {
                }
                return ErrorHandlerController;
            })();
            angular.module("jcsfApp")
                .controller("ErrorHandlerController", ErrorHandlerController);
        })(auth = app.auth || (app.auth = {}));
    })(app = jcsfApp.app || (jcsfApp.app = {}));
})(jcsfApp || (jcsfApp = {}));
